// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AW x5","wrapperNeon":"AX yf","addMyListButton":"AY yd"};